import { useEffect, useContext } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'

import { validContext } from '../lib/validContext'

import Home from './Home'
import HomeNavigation from './HomeNavigation'
import Project from './Project'
import ProjectAccess from './ProjectAccess'
import Answers from './Answers'
import Intents from './Intents'
import Voices from './Voices'
import ChatbotTool from './ChatbotTool'
import Report from './Report'
import Settings from './Settings'
import Page404 from './Page404'
import Footer from '../components/Footer'
import GeneralReports from './Reports/GeneralReports'
import ReportLogs from './ReportLogs'
import HomeGenAI from './GenIA/HomeGenAI' 
import ProjectGenAI from './GenIA/ProjectGenAI' 
import SettingsGenAI from './GenIA/SettingsGenAI'
import GuideGenAI from './GenIA/GuideGenAI'
import CostCenter from './CostCenter'
import PromptLibrary from './PromptLibrary'
import ClientsConfig from './ClientsConfig'
import ReleaseNotifications from './ReleaseNotifications'
import Campaigns from './Campaigns'
import Courses from './Courses'
import CampaignCustomizable from './CampaignCustomizable'
import { initFormChangeWatcher } from '../lib/formChangeWatcher'
//import ClientsConfigGenAI from './GenIA/ClientsConfigGenAI'

export default function AppRoutes() {
  let location = useLocation()
  const [isValid, setIsValid, isInValidation, setIsInValidation] =
    useContext(validContext)

  /*useEffect(() => {
    setIsInValidation(true)

    const cleanup = initFormChangeWatcher();

    return cleanup;
  }, [location.pathname])*/

  return (
    <>
      <Routes>
        <Route path="/" element={<HomeNavigation />} />
        <Route path="/projects" element={<HomeGenAI />} />
        <Route path="/:name" element={<Project />} />
        <Route path="/:name/GenAI" element={<ProjectGenAI />} />
        <Route path="/:name/Answers" element={<Answers />} />
        <Route path="/:name/Intents" element={<Intents />} />
        <Route path="/:name/ChatbotTool" element={<ChatbotTool />} />
        <Route path="/:name/Report/:id" element={<Report />} />
        <Route path="/:name/Settings" element={<Settings />} />
        <Route path="/:name/SettingsGenAI" element={<SettingsGenAI />} />
        <Route path="/:name/GuideGenAI" element={<GuideGenAI />} />
        <Route path="/Voices" element={<Voices />} />
        <Route path="/project-reports" element={<GeneralReports />} />
        <Route path="/:name/changes-logs" element={<ReportLogs />} />
        <Route path="/:name/changes-logsGenAI" element={<ReportLogs />} />
        <Route path="/excel/:name" element={<HomeGenAI />} />
        <Route path="/cost_center" element={<CostCenter />} />
        <Route path="/prompt-library" element={<PromptLibrary />} />
        <Route path="/:name/users" element={<ClientsConfig />} />
        <Route path="/:name/UsersGenAI" element={<ClientsConfig />} />
        <Route path="/project-access" element={<ProjectAccess />} />
        <Route path="/release-notifications" element={<ReleaseNotifications />} />
        <Route path="/campaigns" element={<Campaigns />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/campaign/:campaign_id/customizable/:campaign_name" element={<CampaignCustomizable />} />
        <Route path="*" element={<HomeGenAI />} />
      </Routes>
      {/* <Footer /> */}
    </>
  )
}
